import kuldottekListaja from './kuldottek-listaja.pug';

const MODULE_NAME = 'kuldottekListaja';
class KuldottekListajaController {
	constructor() {
		'ngInject';
	}
	$onInit() {
		this.kuldottekListajaTitle = window.kuldottekListajaTitle;
		this.kuldottekListajaLabel = window.kuldottekListajaLabel;
		this.kuldottekListaja = window.kuldottekListaja;
		this.selectedYear = Object.keys(this.kuldottekListaja)[0];
	}
}

export default angular.module(MODULE_NAME, [])
	.component(MODULE_NAME, {
		controller: KuldottekListajaController,
		template: kuldottekListaja(),
		bindings: {
		}
	}).name;




// WEBPACK FOOTER //
// ../source/application/kuldottek-listaja/kuldottek-listaja.js